import { ClickAwayListener, makeStyles } from '@material-ui/core'
import React from 'react'
import { TemplatePageNavigation } from '../../components/previews/TemplatePageNavigation'
import { TemplatePage } from '../../components/previews/TemplatePage'
import { usePreviewDisplayContext } from '../../components/PreviewDisplayContext'
import { SelectedBlockEditCard } from './SelectedBlockEditCard'

const useStyles = makeStyles((theme) => ({
  templateContentContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '1rem',
    position: 'relative'
  },
  placeholder: {
    color: 'var(--text-color-main)',
    textAlign: 'center',
    fontSize: '1.2rem'
  }
}))

export const InfographicTemplateDisplay = () => {
  const classes = useStyles()
  const { setSelectedBlockId } = usePreviewDisplayContext()
  return (
    <div className={classes.templateContentContainer}>
      <TemplatePageNavigation />
      <ClickAwayListener onClickAway={() => setSelectedBlockId(null)}>
        <div>
          <TemplatePage />
          <SelectedBlockEditCard />
        </div>
      </ClickAwayListener>
    </div>
  )
}
